import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import moment from 'moment';

import authContext from '../context/authContext/authContext';
import AddPropdesk from '../components/modals/AddPropdesk';
import EditPropdesk from '../components/modals/EditPropdesk';
import errorHandle from '../utils/errorHandle';

const GET_PROPDESKS_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/getPropdesks";
const DELETE_PROPDESKS_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/deletePropdesk";

const getYearsArray = () => {
  const years = [];
  for (let i = START_YEAR; i <= END_YEAR; i) {
    years.push(i);
    i += 1
  }
  return years;
}

const START_YEAR = 2018;
const END_YEAR = new Date().getFullYear();
const YEARS_ARRAY = getYearsArray();

const Propdesks = () => {
  const { getConfig } = useContext(authContext);
  const config = getConfig();

  const intialState = { loading: false, propdesks: [] }
  const [state, setCompleteState] = useState(intialState)
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }))

  const getPropdesks = async () => {
    setState({ loading: true })
    await axios.get(GET_PROPDESKS_API_END_POINT, config)
      .then((res) => setState({ propdesks: res?.data?.propdesks, loading: false }))
      .catch((err) => {
        setState({ loading: false })
        errorHandle(err)
      })
  }

  const deletePropdesk = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      showCancelButton: true,
      reverseButtons: true // 👈 this does the trick
    }).then((result) => {
      if (result.isConfirmed) {
        confirmDeletePropdesk(id);
      }
    });
  }

  const confirmDeletePropdesk = async (id) => {
    setState({ loading: true })
    const data = { id }
    await axios.post(DELETE_PROPDESKS_API_END_POINT, data, config)
      .then((res) => {
        setState({ loading: false })
        toast.success(res?.data?.message, { position: 'bottom-right' });
        getPropdesks();
      })
      .catch((err) => {
        setState({ loading: false })
        errorHandle(err)
      })
  }

  useEffect(() => {
    getPropdesks();
  }, []);

  return (
    <div className='main-container pb-1'>
      <div className="card-box mb-30">
        <div className='table-card-header'>
          <div className='d-flex align-items-center'>
            <h2 className="h4 mb-0 py-2">GleamDesk Propdesks</h2>
            {state.loading ? (
              <div className='ml-3'>
                <div className="spinner-border spinner-border-sm text-primary" role="status" />
              </div>
            ) : null}
          </div>
          <div>
            <button className='btn gleamdesk-blue' onClick={() => setState({ openAddPropdeskModal: true })} disabled={state.loading}>
              <i className='fa fa-plus mr-1' />
              <span>Add Propdesk</span>
            </button>
          </div>
        </div>
        <div className="overflow-x-scroll">
          <table className="table table-hover">
            <thead>
              <tr>
                <th scope="col">Propdesk</th>
                <th scope="col">Percentage</th>
                <th scope="col">Status</th>
                <th scope="col">Created At</th>
                <th scope="col">Last Update</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {(state?.propdesks || []).map((propdesk) => {
                const { _id, month, year, percentage, status, createdAt, updatedAt } = propdesk;
                return (
                  <tr key={_id}>
                    <th scope="row">{month} - {year}</th>
                    <td><strong>{percentage}%</strong></td>
                    <td>
                      {status === 'Up' ? (
                        <span className='badge badge-pill gleamdesk-orange px-3 py-2'>{status}</span>
                      ) : (
                        <span className='badge badge-danger badge-pill px-3 py-2'>{status}</span>
                      )}
                    </td>
                    <td>{moment(createdAt).format("dddd, MMMM Do YYYY, h:mm a")}</td>
                    <td>{moment(updatedAt).format("dddd, MMMM Do YYYY, h:mm a")}</td>
                    <td className='actions-container'>
                      <button className='btn btn-secondary btn-sm my-1 mx-1' onClick={() => setState({ openEditPropdeskModal: true, propdeskId: _id })} disabled={state.loading}>
                        <i className='fa fa-pencil' />
                      </button>
                      <button className='btn btn-danger btn-sm my-1 mx-1' onClick={() => deletePropdesk(_id)} disabled={state.loading}>
                        <i className='fa fa-trash' />
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>

      <AddPropdesk
        key={() => new Date()}
        isOpen={state?.openAddPropdeskModal}
        toggle={() => setState({ openAddPropdeskModal: false })}
        getPropdesks={getPropdesks}
        YEARS_ARRAY={YEARS_ARRAY}
        END_YEAR={END_YEAR}
      />

      <EditPropdesk
        key={() => new Date()}
        isOpen={state?.openEditPropdeskModal}
        toggle={() => setState({ openEditPropdeskModal: false, propdeskId: null })}
        propdesks={state.propdesks}
        getPropdesks={getPropdesks}
        YEARS_ARRAY={YEARS_ARRAY}
        propdeskId={state?.propdeskId}
      />
    </div>
  )
}

export default Propdesks